import React from "react";
import { OI } from "../onam/mark";
import { FEATURES } from "../onam/features";

interface ReloadIconProps {
  className?: string;
  title?: string;
  onClick?: () => void | Promise<void>;
}

const BaseReloadIcon: React.FC<ReloadIconProps> = ({
  className = "",
  title = "Reload",
  onClick,
}) => (
  <svg
    fill="currentColor"
    height="18px"
    width="18px"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    className={className}
    onClick={onClick}
    style={onClick ? { cursor: "pointer" } : undefined}
  >
    <title>{title}</title>
    <g>
      <g>
        <path
          d="M511.957,185.214L512,15.045l-67.587,67.587l-7.574-7.574c-48.332-48.332-112.593-74.95-180.946-74.95
          C114.792,0.107,0,114.901,0,256s114.792,255.893,255.893,255.893S511.785,397.099,511.785,256h-49.528
          c0,113.79-92.575,206.365-206.365,206.365S49.528,369.79,49.528,256S142.103,49.635,255.893,49.635
          c55.124,0,106.947,21.467,145.925,60.445l7.574,7.574l-67.58,67.58L511.957,185.214z"
        />
      </g>
    </g>
  </svg>
);

/* With the ONAM skin (FEATURES.curationSkin) this draws ONAM's "refresh" glyph instead (onam/mark.tsx). */
const ReloadIconSkin = (props: any) =>
  FEATURES.curationSkin ? (
    <OI n="refresh" size={props.size || 14} className={props.className} style={props.style} onClick={props.onClick} title={props.title} color={props.color}
      onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} />
  ) : (
    <BaseReloadIcon {...props} />
  );
export const ReloadIcon = ReloadIconSkin;
